import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const AccountIcon = ({
  title = 'Account',
  viewBox = '0 0 14 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" d="M6.727 0C4.602 0 2.883 1.672 2.883 3.734c0 1.645 1.097 3.043 2.617 3.54C2.355 7.886 0 10.82 0 14.311c0 .516.43.934.96.934.532 0 .962-.418.962-.934 0-2.94 2.176-5.289 4.805-5.289 2.628 0 4.804 2.348 4.804 5.29 0 .515.43.933.957.933.532 0 .961-.418.961-.934 0-3.492-2.355-6.425-5.5-7.039 1.524-.496 2.621-1.894 2.621-3.539C10.57 1.672 8.848 0 6.727 0zm0 1.867c1.058 0 1.921.836 1.921 1.867 0 1.032-.863 1.868-1.921 1.868-1.063 0-1.922-.836-1.922-1.868 0-1.03.86-1.867 1.922-1.867zm0 0" />
  </CreateIconComponent>
);

export default AccountIcon;
